import { decode } from 'html-entities';

export const stripHtmlDecode = (html: string) => {
  const regexForStripHTML = /(<([^>]+)>)/gi;

  return decode(html.replaceAll(regexForStripHTML, ''));
};
export default stripHtmlDecode;
